export enum TOOLTIP_POSITION {
  TOP = 'tooltip--top',
  RIGHT = 'tooltip--right',
  BOTTOM = 'tooltip--bottom',
  LEFT = 'tooltip--left'
}
